const ROLE = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  PARTNER: 'partner',
  DEVELOPER: 'developer',
  CUSTOMER: 'customer',
};

export default ROLE;
